export function chooseNamingOption(
  naming: "digestion" | "extraction",
  choices: {
    digestion: string;
    extraction: string;
  },
): string {
  return choices[naming];
}
